import axios from "axios";
import ManageStorage from "src/shared/global/manageStorage";
import authApiConfig from "../auth/authApiConfig";
import _raw from '../../Patient/Reservations/components/data.txt';

const ServicePatient = {
    async getDetail(correoRut) {
        const formData = new FormData();
        formData.append("correoRut", correoRut)
        return await authApiConfig.post("/usuario/detalle", formData, {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            }
        })
    },
    async existsUser(correoRut) {
        try {
            const formData = new FormData();
            formData.append("correoRut", correoRut)
            await authApiConfig.post("/usuario/existe", formData)
            return true;
        } catch (error) {
            return false;
        }
    },
    async getAccountVerified(correoRut) {
        try {
            const formData = new FormData();
            formData.append("correoRut", correoRut)
            await authApiConfig.post("/usuario/cuenta-verificada", formData)
            return false;
        } catch (error) {
            return true;
        }
    },    
    async editPatient(rut, body) {
        return await authApiConfig.put(`/usuario/${rut}`, body, {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            }
        })
    },
    async getReservations(rut, selectReservations = "recientes") {

        let query =  {}; 
        // if(process.env.REACT_APP_SERVICIO == ""){
        //     query = null;
        // }else{
        //     query =  {ser_codigo : process.env.REACT_APP_SERVICIO }; 
        // }

        return await axios.get(`${process.env.REACT_APP_API_AGENDA}/paciente/${rut}/reservas/${selectReservations}`, {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            },
            params: {
                format: 'array',
                ...query
            }
        })
    },
    async savePatient(body) {
        return await authApiConfig.post("/usuario", body);
    },
    async confirmAccount(body) {
        return await authApiConfig.post("/usuario/confirmar-cuenta", body);
    },
    async requestResetPassword(body) {
        return await authApiConfig.post("/usuario/solicitud-nueva-clave", body);
    },
    async verifyPasswordTemporal({ uswEmail, claveTemporal }) {
        const formData = new FormData();
        formData.append("uswEmail", uswEmail)
        formData.append("claveTemporal", claveTemporal)
        return await authApiConfig.post("/usuario/verifica-clave-temporal", formData);
    },
    async resetPassword(body) {
        return await authApiConfig.post("/usuario/resetear-clave", body);
    },
    async resetPasswordProfile(body) {
        return await authApiConfig.post("/usuario/resetear-clave-perfil", body,
            {
                headers: {
                    Authorization: `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
                }
            }
        );
    },
    async resendCodeConfirmation(body) {
        return await authApiConfig.post("/usuario/reenviar-codigo-confirmacion", body);
    },
    async sendCodeDeleteConfirmation(body) {
        return await authApiConfig.post("/usuario/enviar-codigo-eliminacion", body);
    },
    async deleteUser(body) {
        return await authApiConfig.post("/usuario/eliminar-usuario", body);
    },    
    async getViewerExams(rut) {
        return await axios.get(`${process.env.REACT_APP_API_AGENDA}/visualizador-consolidado`, {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            },
            params: {
                username: 'administra',
                password: 'wkGWfewf_p',
                rutPaciente: rut
            }
        })
    },
    async getViewerExamsLab(rut) {

        // axios.defaults.timeout = 100000;
        // axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        // return await axios.get('http://192.168.100.119:52773/examlab/rest/examlab/orden/rut/15592352-0');

        // const response = await fetch(`http://192.168.100.119:52773/examlab/rest/examlab/orden/rut/15592352-0`, {
	    //     'mode': 'cors',
	    //     'headers': {
        //     	'Access-Control-Allow-Origin': '*',
        // 	}
    	// });
        // const orden = await response.json();
        
        // return response;
        axios.defaults.timeout = 60000; // Set default timeout to 5 seconds
        return await axios.get(`${process.env.REACT_APP_SEDE === "Talca" ? process.env.REACT_APP_API_AGENDA_CASCH : process.env.REACT_APP_API_AGENDA}/examlab/orden`, {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            },
            params: {
                tipo_documento: 'rut',
                numero_documento: rut
            }
        })

        // axios.defaults.timeout = 60000; // Set default timeout to 5 seconds
        // return await axios.get(`${process.env.REACT_APP_API_AGENDA}/examlab/orden`, {
        //     headers: {
        //         'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
        //     },
        //     params: {
        //         tipo_documento: 'rut',
        //         numero_documento: '15592352-0'
        //     }
        // })
        //axios.defaults.timeout = 60000; // Set default timeout to 5 seconds
        // return await axios.get(`https://reservaweb.andessaludpuertomontt.cl/gateway/agenda/api/examlab/orden`, {
        //     headers: {
        //         'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
        //     },
        //     params: {
        //         tipo_documento: 'rut',
        //         numero_documento: '15592352-0'
        //     }
        // })

    },
    async getViewerExamsLabBase64(numOrden, numeroExterno, ordenValida, tipoDocumento, numeroDocumento) {
        return await axios.get(`${process.env.REACT_APP_SEDE === "Talca" ? process.env.REACT_APP_API_AGENDA_CASCH : process.env.REACT_APP_API_AGENDA}/examlab/reporte`, {
            headers: {
                'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
            },
            params: {
                numOrden: numOrden,
                numeroExterno: numeroExterno,
                type:'labcore',
                ordenValida: ordenValida,
                tipo_documento: tipoDocumento , 
                numero_documento: numeroDocumento,

            }
        })
    }, 
    async getEmail(body) {
            return await axios.post(`${process.env.REACT_APP_API_BASE_CASC}/agenda/api/email`, body , {
                headers: {
                    'Authorization': `Bearer ${ManageStorage.getValueFromStorage("tokenUser")}`
                }
              });            
            
    }, 
    async getBodyHtml() {
        return await fetch(_raw)
        .then(r => r.text())
        .then(text => {       
          return text
        });           
            
    }, 
}

export default ServicePatient;